module.exports = __webpack_public_path__ + "static/media/boss-tuagom-pic-starting.5069ee94.ogg";